import React from "react";
import { BetOffer, BettingOffer } from "@models";
import { EventType } from "@gp/models";
import classNames from "classnames";
import TeamIcon from "@components/icons/TeamIcon";

export function QuickBetEventName(props: {
	offer: BettingOffer | BetOffer;
	containerClassName?: string;
}) {
	const { offer } = props;

	const nameClasses = classNames("slip__event__title", {
		"bet__name--event": offer.sportData.eventType !== EventType.NORMAL,
	});

	if (
		offer.sportData.eventType &&
		offer.sportData.eventType !== EventType.NORMAL &&
		offer.sportData.eventName != ""
	) {
		return (
			<div>
				<span className={nameClasses}>{offer.sportData.eventName}</span>
			</div>
		);
	}

	return (
		<>
			<span className={nameClasses}>
				<span className="slip__event__competitors">
					<TeamIcon
						showCountryFlag={offer.sportData?.showCountryFlag ?? false}
						flagCode={offer.sportData?.teamOneCountryCode}
						jerseyTypeAbrv={offer.sportData?.teamOneJerseyTypeAbrv}
						opponentFlagCode={offer.sportData?.teamTwoCountryCode}
						opponentJerseyTypeAbrv={offer.sportData?.teamTwoJerseyTypeAbrv}
						className="card--qp__icon u-icon u-icon--base"
					/>
					{offer.teamOneString}
				</span>{" "}
				-{" "}
				<span className="slip__event__competitors">
					<TeamIcon
						showCountryFlag={offer.sportData?.showCountryFlag ?? false}
						flagCode={offer.sportData?.teamTwoCountryCode}
						jerseyTypeAbrv={offer.sportData?.teamTwoJerseyTypeAbrv}
						opponentFlagCode={offer.sportData?.teamOneCountryCode}
						opponentJerseyTypeAbrv={offer.sportData?.teamOneJerseyTypeAbrv}
						className="card--qp__icon u-icon u-icon--base"
					/>
					{offer.teamTwoString}
				</span>
			</span>
		</>
	);
}
